import api from '../REST/api';
import withResolved from '../REST/with-resolved';

export default function withBrandsAsData(WrappedComponent, search = {}) {
  function deriveQueryArgs({ zmsActive }) {
    return { search: { zmsActive, ...search } };
  }

  return withResolved({
    query: api.getBrands,
    deriveQueryArgs,
    as: 'data',
  })(WrappedComponent);
}
